module.exports = __webpack_public_path__ + "img/noeyes.731318eb.svg";